// ─── omerUtils.js ─────────────────────────────────────────────────────────────
// כל לוגיקת ספירת העומר: חישוב יום, טקסטים עבריים, שמות ספירות

// ─── Month mapping (מס׳ חודש עברי לפי שם באנגלית מה-HebCal API) ─────────────
export const MONTH_NAME_TO_NUM = {
  Nisan: 1, Iyyar: 2, Sivan: 3, Tamuz: 4, Av: 5, Elul: 6,
  Tishrei: 7, Cheshvan: 8, Kislev: 9, Tevet: 10, "Sh'vat": 11,
  Adar: 12, "Adar I": 12, "Adar II": 13,
};

// ─── Hebrew number words (יום X — זכר) ────────────────────────────────────────
const OMER_DAY_WORDS = {
  1:  'אֶחָד',          2:  'שְׁנַיִם',        3:  'שְׁלֹשָׁה',
  4:  'אַרְבָּעָה',    5:  'חֲמִשָּׁה',       6:  'שִׁשָּׁה',
  7:  'שִׁבְעָה',      8:  'שְׁמֹנָה',        9:  'תִּשְׁעָה',
  10: 'עֲשָׂרָה',      11: 'אַחַד עָשָׂר',    12: 'שְׁנֵים עָשָׂר',
  13: 'שְׁלֹשָׁה עָשָׂר', 14: 'אַרְבָּעָה עָשָׂר', 15: 'חֲמִשָּׁה עָשָׂר',
  16: 'שִׁשָּׁה עָשָׂר',   17: 'שִׁבְעָה עָשָׂר',   18: 'שְׁמֹנָה עָשָׂר',
  19: 'תִּשְׁעָה עָשָׂר',  20: 'עֶשְׂרִים',
  21: 'אֶחָד וְעֶשְׂרִים',      22: 'שְׁנַיִם וְעֶשְׂרִים',
  23: 'שְׁלֹשָׁה וְעֶשְׂרִים',  24: 'אַרְבָּעָה וְעֶשְׂרִים',
  25: 'חֲמִשָּׁה וְעֶשְׂרִים',  26: 'שִׁשָּׁה וְעֶשְׂרִים',
  27: 'שִׁבְעָה וְעֶשְׂרִים',   28: 'שְׁמֹנָה וְעֶשְׂרִים',
  29: 'תִּשְׁעָה וְעֶשְׂרִים',  30: 'שְׁלֹשִׁים',
  31: 'אֶחָד וּשְׁלֹשִׁים',     32: 'שְׁנַיִם וּשְׁלֹשִׁים',
  33: 'שְׁלֹשָׁה וּשְׁלֹשִׁים', 34: 'אַרְבָּעָה וּשְׁלֹשִׁים',
  35: 'חֲמִשָּׁה וּשְׁלֹשִׁים', 36: 'שִׁשָּׁה וּשְׁלֹשִׁים',
  37: 'שִׁבְעָה וּשְׁלֹשִׁים',  38: 'שְׁמֹנָה וּשְׁלֹשִׁים',
  39: 'תִּשְׁעָה וּשְׁלֹשִׁים', 40: 'אַרְבָּעִים',
  41: 'אֶחָד וְאַרְבָּעִים',     42: 'שְׁנַיִם וְאַרְבָּעִים',
  43: 'שְׁלֹשָׁה וְאַרְבָּעִים', 44: 'אַרְבָּעָה וְאַרְבָּעִים',
  45: 'חֲמִשָּׁה וְאַרְבָּעִים', 46: 'שִׁשָּׁה וְאַרְבָּעִים',
  47: 'שִׁבְעָה וְאַרְבָּעִים',  48: 'שְׁמֹנָה וְאַרְבָּעִים',
  49: 'תִּשְׁעָה וְאַרְבָּעִים',
};

// שבועות (לשון זכר)
const WEEK_WORDS = {
  1: 'שָׁבוּעַ אֶחָד',        2: 'שְׁנֵי שָׁבוּעוֹת',
  3: 'שְׁלֹשָׁה שָׁבוּעוֹת',  4: 'אַרְבָּעָה שָׁבוּעוֹת',
  5: 'חֲמִשָּׁה שָׁבוּעוֹת',  6: 'שִׁשָּׁה שָׁבוּעוֹת',
  7: 'שִׁבְעָה שָׁבוּעוֹת',
};

// ימים בתוך שבוע (לשון זכר)
const DAY_IN_WEEK_WORDS = {
  1: 'יוֹם אֶחָד',    2: 'שְׁנֵי יָמִים',    3: 'שְׁלֹשָׁה יָמִים',
  4: 'אַרְבָּעָה יָמִים', 5: 'חֲמִשָּׁה יָמִים', 6: 'שִׁשָּׁה יָמִים',
};

// ─── ספירות (קבלה) ────────────────────────────────────────────────────────────
const SEFIROT = ['חֶסֶד', 'גְּבוּרָה', 'תִּפְאֶרֶת', 'נֶצַח', 'הוֹד', 'יְסוֹד', 'מַלְכוּת'];
const SEFIROT_SHEL = [
  'שֶׁבְּחֶסֶד', 'שֶׁבִּגְבוּרָה', 'שֶׁבִּתְפְאֶרֶת',
  'שֶׁבְּנֶצַח', 'שֶׁבְּהוֹד', 'שֶׁבִּיסוֹד', 'שֶׁבְּמַלְכוּת',
];

// ─── אותיות ספירה (ל״ג, מ״ה...) ──────────────────────────────────────────────
const HEBREW_LETTERS = ['', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט'];
const HEBREW_TENS    = ['', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ'];
const HEBREW_HUNDREDS = { 100: 'ק', 200: 'ר', 300: 'ש', 400: 'ת' };

// ─── חישוב יום העומר ─────────────────────────────────────────────────────────
/**
 * @param {number} hMonth  — מספר חודש עברי (1=ניסן, 2=אייר, 3=סיון)
 * @param {number} hDay    — יום בחודש
 * @returns {number|null}  — 1–49 או null מחוץ לעונה
 */
export function calculateOmerDay(hMonth, hDay) {
  if (hMonth === 1 && hDay >= 16 && hDay <= 30) return hDay - 15;
  if (hMonth === 2 && hDay >= 1  && hDay <= 29) return hDay + 15;
  if (hMonth === 3 && hDay >= 1  && hDay <= 5)  return hDay + 44;
  return null;
}

/**
 * @param {number} omerDay — 1–49
 * @returns {{ weeks: number, dayInWeek: number }}
 */
export function getWeekData(omerDay) {
  const weeks     = Math.floor((omerDay - 1) / 7);
  const dayInWeek = ((omerDay - 1) % 7) + 1;
  return { weeks, dayInWeek };
}

/**
 * מחזיר את שם הספירה הקבלית ליום הנתון.
 * @param {number} omerDay
 * @returns {string}
 */
export function getSefirahName(omerDay) {
  const weekIndex = Math.floor((omerDay - 1) / 7);
  const dayIndex  = (omerDay - 1) % 7;
  return `${SEFIROT[dayIndex]} ${SEFIROT_SHEL[weekIndex]}`;
}

/**
 * ממיר מספר לאות עברית (ל״ג, מ״ה וכו׳).
 * @param {number} n — 1–49
 * @returns {string}
 */
export function getOmerDayHebrew(n) {
  if (n <= 0 || n > 49) return '';
  if (n === 15) return 'ט״ו';
  if (n === 16) return 'ט״ז';
  const ones = n % 10;
  const tens = Math.floor(n / 10) * 10;
  const hundredsVal = Math.floor(n / 100) * 100;

  let result = '';
  if (hundredsVal) result += HEBREW_HUNDREDS[hundredsVal] || '';
  if (tens)  result += HEBREW_TENS[Math.floor(n / 10) % 10];
  if (ones)  result += HEBREW_LETTERS[ones];

  // גרשיים
  if (result.length === 1)  return result + '׳';
  if (result.length === 2)  return result[0] + '״' + result[1];
  return result.slice(0, -1) + '״' + result.slice(-1);
}

/**
 * בונה את שורות הספירה הראשיות.
 * @param {number} omerDay
 * @param {'ashkenaz'|'sephardic'|'mizrahi'} nusach
 * @returns {{ mainLine: string, subLine: string|null }}
 */
export function getOmerCountText(omerDay, nusach = 'ashkenaz') {
  const suffix    = nusach === 'ashkenaz' ? 'בָּעֹמֶר' : 'לָעֹמֶר';
  const isMizrahi = nusach === 'mizrahi';
  const dayWord   = OMER_DAY_WORDS[omerDay] || String(omerDay);

  // יום א׳: "הַיּוֹם יוֹם אֶחָד" — ימים ב׳ ואילך: "הַיּוֹם שְׁנַיִם יָמִים"
  const dayPhrase = omerDay === 1
    ? `יוֹם ${dayWord}`
    : omerDay <= 10
      ? `${dayWord} יָמִים`
      : `${dayWord} יוֹם`;

  let subLine = null;
  if (omerDay >= 7) {
    const { weeks, dayInWeek } = getWeekData(omerDay);
    const base = dayInWeek === 7
      ? `שֶׁהֵם ${WEEK_WORDS[weeks + 1]}`
      : `שֶׁהֵם ${WEEK_WORDS[weeks]} וְ${DAY_IN_WEEK_WORDS[dayInWeek]}`;
    // אשכנז/ספרד: הסיומת בסוף "שהם..." — מזרח: הסיומת במשפט הראשי
    subLine = isMizrahi ? base : `${base} ${suffix}`;
  }

  // מזרח: הסיומת מיד אחרי המספר — אשכנז/ספרד: הסיומת בסוף "שהם..." (כשיש)
  const mainLine = (isMizrahi || !subLine)
    ? `הַיּוֹם ${dayPhrase} ${suffix}`
    : `הַיּוֹם ${dayPhrase}`;

  return { mainLine, subLine };
}

// ─── טקסטים קבועים ────────────────────────────────────────────────────────────

export const BRACHA_TEXT =
  'בָּרוּךְ אַתָּה יְיָ אֱלֹהֵינוּ מֶלֶךְ הָעוֹלָם, ' +
  'אֲשֶׁר קִדְּשָׁנוּ בְּמִצְוֹתָיו וְצִוָּנוּ עַל סְפִירַת הָעֹמֶר.';

export const LESHEM_YICHUD_LINES = [
  'לְשֵׁם יִחוּד קֻדְשָׁא בְּרִיךְ הוּא וּשְׁכִינְתֵּיהּ, בִּדְחִילוּ וּרְחִימוּ וּרְחִימוּ וּדְחִילוּ, לְיַחֵד שֵׁם יוּ״ד הֵ״א בְּוָא״ו הֵ״א בְּיִחוּדָא שְׁלִים, בְּשֵׁם כָּל יִשְׂרָאֵל.',
  'הִנְנִי מוּכָן וּמְזֻמָּן לְקַיֵּים מִצְוַת עֲשֵׂה שֶׁל סְפִירַת הָעֹמֶר, כְּמוֹ שֶׁכָּתוּב בַּתּוֹרָה: וּסְפַרְתֶּם לָכֶם מִמָּחֳרַת הַשַּׁבָּת מִיּוֹם הֲבִיאֲכֶם אֶת עֹמֶר הַתְּנוּפָה שֶׁבַע שַׁבָּתוֹת תְּמִימֹת תִּהְיֶינָה.',
];

export const PASUK_VE_SAFARTEM =
  'וּסְפַרְתֶּם לָכֶם מִמָּחֳרַת הַשַּׁבָּת מִיּוֹם הֲבִיאֲכֶם אֶת עֹמֶר הַתְּנוּפָה שֶׁבַע שַׁבָּתוֹת תְּמִימֹת תִּהְיֶינָה: עַד מִמָּחֳרַת הַשַּׁבָּת הַשְּׁבִיעִת תִּסְפְּרוּ חֲמִשִּׁים יוֹם וְהִקְרַבְתֶּם מִנְחָה חֲדָשָׁה לַיְיָ.';

export const PASUK_SHEVA_SHABATOT =
  'שֶׁבַע שַׁבָּתוֹת תְּמִימֹת תִּהְיֶינָה: עַד מִמָּחֳרַת הַשַּׁבָּת הַשְּׁבִיעִת תִּסְפְּרוּ חֲמִשִּׁים יוֹם.';

export const HARACHAMAN_TEXT =
  'הָרַחֲמָן הוּא יַחֲזִיר לָנוּ עֲבוֹדַת בֵּית הַמִּקְדָּשׁ לִמְקוֹמָהּ בִּמְהֵרָה בְיָמֵינוּ אָמֵן סֶלָה.';

export const PSALM_67_VERSES = [
  { id: 'p67_header', text: 'לַמְנַצֵּחַ בִּנְגִינֹת מִזְמוֹר שִׁיר:' },
  { id: 'p67_1', text: 'אֱלֹהִים יְחָנֵּנוּ וִיבָרְכֵנוּ, יָאֵר פָּנָיו אִתָּנוּ סֶלָה:' },
  { id: 'p67_2', text: 'לָדַעַת בָּאָרֶץ דַּרְכֶּךָ, בְּכָל גּוֹיִם יְשׁוּעָתֶךָ:' },
  { id: 'p67_3', text: 'יוֹדוּךָ עַמִּים אֱלֹהִים, יוֹדוּךָ עַמִּים כֻּלָּם:' },
  { id: 'p67_4', text: 'יִשְׂמְחוּ וִירַנְּנוּ לְאֻמִּים, כִּי תִשְׁפֹּט עַמִּים מִישֹׁר, וּלְאֻמִּים בָּאָרֶץ תַּנְחֵם סֶלָה:' },
  { id: 'p67_5', text: 'יוֹדוּךָ עַמִּים אֱלֹהִים, יוֹדוּךָ עַמִּים כֻּלָּם:' },
  { id: 'p67_6', text: 'אֶרֶץ נָתְנָה יְבוּלָהּ, יְבָרְכֵנוּ אֱלֹהִים אֱלֹהֵינוּ:' },
  { id: 'p67_7', text: 'יְבָרְכֵנוּ אֱלֹהִים וְיִירְאוּ אֹתוֹ כָּל אַפְסֵי אָרֶץ:' },
];

export const ANA_BKOACH_LINES = [
  { id: 'ab1', text: 'אָנָּא בְּכֹחַ גְּדֻלַּת יְמִינְךָ, תַּתִּיר צְרוּרָה:' },
  { id: 'ab2', text: 'קַבֵּל רִנַּת עַמְּךָ, שַׂגְּבֵנוּ טַהֲרֵנוּ נוֹרָא:' },
  { id: 'ab3', text: 'נָא גִבּוֹר, דּוֹרְשֵׁי יִחוּדְךָ, כְּבָבַת שָׁמְרֵם:' },
  { id: 'ab4', text: 'בָּרְכֵם טַהֲרֵם, רַחֲמֵי צִדְקָתְךָ תָּמִיד גָּמְלֵם:' },
  { id: 'ab5', text: 'חֲסִין קָדוֹשׁ, בְּרֹב טוּבְךָ נַהֵל עֲדָתֶךָ:' },
  { id: 'ab6', text: 'יָחִיד גֵּאֶה, לְעַמְּךָ פְּנֵה, זוֹכְרֵי קְדֻשָּׁתֶךָ:' },
  { id: 'ab7', text: 'שַׁוְעָתֵנוּ קַבֵּל וּשְׁמַע צַעֲקָתֵנוּ, יוֹדֵעַ תַּעֲלוּמוֹת:' },
];

export const OFF_SEASON_MESSAGE = 'ספירת העומר אינה נוהגת בימים אלו';

// ─── ספירה לאחור עד תחילת העומר ─────────────────────────────────────────────

/** אורך חודשים עבריים (ברירת מחדל — חשוון 29, כסלו 30) */
const MONTH_LENGTHS = (isLeap) => ({
  1: 30, 2: 29, 3: 30, 4: 29, 5: 30, 6: 29,
  7: 30, 8: 29, 9: 30, 10: 29, 11: 30,
  12: isLeap ? 30 : 29,
  13: 29,
});

/**
 * מחזיר כמה ימים עבריים נותרו עד ט״ז ניסן (תחילת ספירת העומר).
 * @param {number} hMonth — חודש עברי (1=ניסן)
 * @param {number} hDay   — יום בחודש
 * @param {boolean} isLeapYear
 * @returns {number|null} — מספר ימים, או null אם אנחנו בעונת העומר
 */
export function getDaysUntilOmer(hMonth, hDay, isLeapYear = false) {
  // בעונת העומר — לא צריך ספירה לאחור
  if (hMonth === 1 && hDay >= 16) return null;
  if (hMonth === 2) return null;
  if (hMonth === 3 && hDay <= 5) return null;

  // ניסן לפני ט״ז
  if (hMonth === 1 && hDay < 16) return 16 - hDay;

  // חישוב ימים מהתאריך הנוכחי עד ט״ז ניסן
  const ml = MONTH_LENGTHS(isLeapYear);
  const maxMonth = isLeapYear ? 13 : 12;

  let days = ml[hMonth] - hDay; // ימים שנותרו בחודש הנוכחי
  let m = hMonth + 1;
  while (true) {
    if (m > maxMonth) m = 1;
    if (m === 1) break;
    days += ml[m];
    m++;
  }
  days += 16; // ימים בניסן עד ט״ז
  return days;
}

/**
 * מחזיר טקסט ספירה לאחור בעברית.
 * @param {number} daysLeft
 * @returns {string}
 */
export function getPreviewCountdownText(daysLeft) {
  if (daysLeft === 1) return 'ספירת העומר מתחילה הערב';
  if (daysLeft === 2) return 'ספירת העומר מתחילה מחר בערב';
  return `ספירת העומר תחל בעוד ${daysLeft} ימים`;
}

// ─── שם שבוע נוכחי ─────────────────────────────────────────────────────────
export const WEEK_NUMBER_LABEL = {
  1: 'שבוע ראשון — חֶסֶד',
  2: 'שבוע שני — גְּבוּרָה',
  3: 'שבוע שלישי — תִּפְאֶרֶת',
  4: 'שבוע רביעי — נֶצַח',
  5: 'שבוע חמישי — הוֹד',
  6: 'שבוע שישי — יְסוֹד',
  7: 'שבוע שביעי — מַלְכוּת',
};
